<script lang="ts" setup>
import { computed } from 'vue';

import type { AppCircleCheckboxTheme } from './AppCircleCheckbox.model';

interface UncheckedProps {
  theme: AppCircleCheckboxTheme;
}

const props = defineProps<UncheckedProps>();

const strokeColor = computed(() =>
  props.theme === 'radio' ? '#918F99' : '#E3E1E9'
);

const strokeWidth = computed(() => (props.theme === 'radio' ? '2' : '3'));
</script>

<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.3359"
      cy="12"
      r="10.5"
      fill="white"
      :stroke="strokeColor"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>
